<div class="wrap">
  <app-modal-generic-header
    [header]="'@components.subsidyCodeActivation.header' | translate"
    (closeClicked)="modalService.dismiss(false)"
  ></app-modal-generic-header>
  <div class="form">
    <app-input
      [control]="codeControl"
      [inputType]="'text'"
      [isMarkedAsRequired]="true"
      [label]="'@components.subsidyCodeActivation.form.code.label' | translate"
      [placeholder]="
        '@components.subsidyCodeActivation.form.code.placeholder' | translate
      "
    ></app-input>
    <div
      *ngIf="codeControl.touched && codeControl.errors !== null"
      class="validation-message"
    >
      {{ "@components.subsidyCodeActivation.form.validationError" | translate }}
    </div>
  </div>
  <app-action-button
    [label]="'@components.subsidyCodeActivation.cta' | translate"
    (click)="onActivateClick()"
    [disabled]="codeControl.invalid || (loader.isLoading$ | async)!"
    class=""
  ></app-action-button>
</div>
